import React, { useState,useEffect } from 'react'
import Tcnavbar from '../Components/Tcnavbar'
import Tcsidebar from '../Components/Tcsidebar'
import TcTermsMain from '../Components/TcTermsMain'
import {Link} from 'react-router-dom'

const TcTerms = () => {
    const[sidebar,setSidebarOpen]= useState(false);
    const[name,setName]= useState([localStorage.getItem('username')]);

    const togglesidebar = ()=> {
      setSidebarOpen((prevState) => !prevState);
    }

    useEffect(()=>{

      const venture = localStorage.getItem('ventureid');
      let TCcheck = venture.includes('01')
   
  if(TCcheck==true){
    document.getElementById("TC-dashboard").style.display="grid"
  }
  else{
    document.getElementById("TC-dashboard").style.display="none"
 
}

 },[]);
  
   function closeForm()
     {
        document.getElementById("modalLogoutForm").style.display = "none";
      
      }
  
      function Confirm() {      
          localStorage.clear();
        }
  
  
  function Cancel() {
     document.getElementById("modalLogoutForm").style.display = "none";      
  
        }
        function logoutform(){
          document.getElementById("modalLogoutForm").style.display = "block";
        }

  return (
    <div className='tc-container' id="TC-dashboard">
        <Tcnavbar sidebar={sidebar} openSidebar = {togglesidebar}/>
        <Tcsidebar sidebar={sidebar} formopen={logoutform} />
         <TcTermsMain />
        
         <div className="TCpopfade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
            <h5>Are you sure want to&nbsp;<span style={{color:"blue"}}>Logout?</span></h5>
            <h5 style={{color:"#ff6a00"}}>{name}</h5>
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className='TC-logout-button' onClick={Confirm} type='submit'>Confirm</button></Link>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>
      </div>
  )
}

export default TcTerms
